module.exports = __webpack_public_path__ + "static/media/kensieMae.c7d2ea08.png";